function initProductCards() {
  // Only get cards that haven't been initialized yet
  const allCards = document.querySelectorAll(
    ".card-product:not([data-card-initialized])"
  );

  allCards.forEach((product) => {
    // Mark card as initialized to prevent duplicate listeners
    product.setAttribute("data-card-initialized", "true");

    const mainImage = product.querySelector(
      ".card-product__image:not(.next_image)"
    );
    const nextImage = product.querySelector(".card-product__image.next_image");
    const imageContainer = product.querySelector(
      ".card-product__image-container"
    );

    // Only add hover effect if next image exists
    if (nextImage && mainImage && imageContainer) {
      // 🖱 Hover emulation for desktop — fixes double-tap on mobile
      imageContainer.addEventListener("mouseenter", () => {
        product.classList.add("hovered");
      });

      imageContainer.addEventListener("mouseleave", () => {
        product.classList.remove("hovered");
      });
    }

    // 🎨 Handle color swatches (both related products and variant colors)
    product.addEventListener("click", (e) => {
      const colorOption = e.target.closest(
        ".card-product__color-option:not(.disabled)"
      );
      if (colorOption) {
        e.preventDefault();
        e.stopPropagation();

        // Check if it's a related product color swatch
        const relatedColorsContainer = colorOption.closest(
          "[data-related-colors]"
        );
        if (relatedColorsContainer) {
          handleRelatedProductColorSwatch(colorOption, product);
        } else {
          handleColorSwatch(colorOption, product);
        }
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initProductCards();
  window.initProductCards = initProductCards;
});

function handleColorSwatch(colorOption, productCard) {
  if (colorOption.getAttribute("aria-current") === "true") return;

  const featuredImage = productCard.querySelector(
    ".card-product__image-container .card-product__image"
  );

  colorOption
    .closest(".card-product__colors")
    .querySelectorAll(".card-product__color-option")
    .forEach((btn) => btn.setAttribute("aria-current", "false"));

  colorOption.setAttribute("aria-current", "true");

  const newImageSrc = colorOption.dataset.imageSrc;
  const newAltText = colorOption.dataset.imageAlt;

  if (featuredImage && newImageSrc) {
    featuredImage.src = newImageSrc;
    featuredImage.alt = newAltText;
  }
}

function handleRelatedProductColorSwatch(colorOption, productCard) {
  if (colorOption.classList.contains("active")) return;

  // Update active state
  const colorsContainer = colorOption.closest(".card-product__colors");
  if (colorsContainer) {
    colorsContainer
      .querySelectorAll(".card-product__color-option")
      .forEach((btn) => btn.classList.remove("active"));
  }
  colorOption.classList.add("active");

  // Get product data from the color option
  const productId = colorOption.dataset.productId;
  const productImage = colorOption.dataset.productImage;
  const productNextImage = colorOption.dataset.productNextImage;
  const productPrice = colorOption.dataset.productPrice;
  const productComparePrice = colorOption.dataset.productComparePrice;
  const productHandle = colorOption.dataset.productHandle;

  // Update images with clip-path animation
  const mainImage = productCard.querySelector(
    ".card-product__image:not(.next_image)"
  );
  const nextImage = productCard.querySelector(
    ".card-product__image.next_image"
  );
  const imageContainer = mainImage?.parentElement;

  if (mainImage && productImage) {
    // If next image exists, use clip-path reveal animation
    if (nextImage && productNextImage) {
      // Set new images
      nextImage.src = productNextImage;
      nextImage.dataset.productNextImage = productNextImage;
      mainImage.src = productImage;
      mainImage.dataset.productImage = productImage;

      // Trigger clip-path animation
      productCard.classList.remove("color-changing");
      void productCard.offsetWidth; // Force reflow
      productCard.classList.add("color-changing");

      // Remove class after animation completes
      setTimeout(() => {
        productCard.classList.remove("color-changing");
      }, 300);
    } else if (productNextImage && mainImage) {
      // Create next image if it doesn't exist
      const newNextImage = document.createElement("img");
      newNextImage.src = productNextImage;
      newNextImage.className = "card-product__image next_image";
      newNextImage.dataset.productNextImage = productNextImage;
      newNextImage.width = 300;
      newNextImage.height = 300;
      if (imageContainer) {
        imageContainer.appendChild(newNextImage);

        // Set main image
        mainImage.src = productImage;
        mainImage.dataset.productImage = productImage;

        // Trigger clip-path animation
        productCard.classList.remove("color-changing");
        void productCard.offsetWidth; // Force reflow
        productCard.classList.add("color-changing");

        // Remove class after animation completes
        setTimeout(() => {
          productCard.classList.remove("color-changing");
        }, 300);
      }
    } else {
      // No next image, just update main image
      mainImage.src = productImage;
      mainImage.dataset.productImage = productImage;
    }
  }

  // Update price
  const currentPriceElement = productCard.querySelector(
    ".card-product__current-price"
  );
  if (currentPriceElement && productPrice) {
    const priceInCents = parseInt(productPrice);
    const formattedPrice = formatMoney(priceInCents);
    currentPriceElement.textContent = formattedPrice;
    currentPriceElement.dataset.currentPrice = productPrice;
  }

  // Update compare price
  const comparePriceElement = productCard.querySelector(
    ".card-product__compare-price"
  );
  if (
    productComparePrice &&
    parseInt(productComparePrice) > parseInt(productPrice)
  ) {
    if (!comparePriceElement) {
      // Create compare price element if it doesn't exist
      const priceContainer = productCard.querySelector(".card-product__price");
      if (priceContainer && currentPriceElement) {
        const newComparePrice = document.createElement("span");
        newComparePrice.className = "card-product__compare-price";
        newComparePrice.dataset.comparePrice = productComparePrice;
        const comparePriceInCents = parseInt(productComparePrice);
        newComparePrice.textContent = formatMoney(comparePriceInCents);
        priceContainer.insertBefore(newComparePrice, currentPriceElement);
      }
    } else {
      const comparePriceInCents = parseInt(productComparePrice);
      comparePriceElement.textContent = formatMoney(comparePriceInCents);
      comparePriceElement.dataset.comparePrice = productComparePrice;
      comparePriceElement.style.display = "";
    }
  } else if (comparePriceElement) {
    // Hide compare price if it doesn't exist or is not greater than current price
    comparePriceElement.style.display = "none";
  }

  // Update product card data attributes
  if (productHandle) {
    productCard.dataset.productHandle = productHandle;
  }
  if (productId) {
    productCard.dataset.productId = productId;
  }
  if (productPrice) {
    productCard.dataset.productPrice = productPrice;
  }
  if (productComparePrice) {
    productCard.dataset.productComparePrice = productComparePrice;
  }

  // Update the link URL
  const productLink = productCard.querySelector(".card__product");
  if (productLink && productHandle) {
    productLink.href = `/products/${productHandle}`;
  }
}

function formatMoney(cents) {
  // Use Shopify's money formatter if available, otherwise fallback
  if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
    return Shopify.formatMoney(
      cents,
      window.money_without_trailing_zeros_format || "${{amount}}"
    );
  }
  // Fallback formatter
  const dollars = (cents / 100).toFixed(2);
  return `$${dollars}`;
}
